import { render, staticRenderFns } from "./OrderItemHeader.vue?vue&type=template&id=09d761ef&scoped=true&"
import script from "./OrderItemHeader.vue?vue&type=script&lang=js&"
export * from "./OrderItemHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d761ef",
  null
  
)

export default component.exports